import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import showSectionMenu from '@shopDetails/utils/menu';
import TabsContainer from './components/TabsContainer';
import SearchIconContainer from './components/SearchIconContainer';
import SearchIcon from './components/SearchIcon';
import Tabs from './components/Tabs';
import MenuShimmer from './components/MenuShimmer';
import MenuButton from '../MenuButton';

const MenuSections = ({
  onFocusSearch,
  onSelectTab,
  menuSections,
  selectedSection,
  isMenuFetched,
  onClickMenu,
  className,
  isPickupFlagEnabled,
}) => {
  const [firstSection] = menuSections || [];
  const showMenu = useMemo(() => showSectionMenu(menuSections), [menuSections]);

  if (!isMenuFetched) {
    return <MenuShimmer className={className} />;
  }

  if (isMenuFetched && menuSections?.length) {
    return (
      <TabsContainer
        className={className}
        withWhiteBackgroundColor={!isPickupFlagEnabled}
      >
        <SearchIconContainer id="search_icon_container">
          <SearchIcon size="small" onClick={onFocusSearch} />
        </SearchIconContainer>
        {showMenu && <MenuButton onClick={onClickMenu} />}
        <Tabs
          swipeable
          tabs={menuSections}
          onSelect={onSelectTab}
          tabSelectedId={selectedSection || firstSection?.id}
          skipScroll={selectedSection !== undefined}
        />
      </TabsContainer>
    );
  }

  return null;
};

MenuSections.propTypes = {
  onFocusSearch: PropTypes.func.isRequired,
  menuSections: PropTypes.array,
  isMenuFetched: PropTypes.bool.isRequired,
  onSelectTab: PropTypes.func.isRequired,
  selectedSection: PropTypes.number,
  onClickMenu: PropTypes.func,
  className: PropTypes.string,
  isPickupFlagEnabled: PropTypes.bool,
};

export default MenuSections;
